import { brandName } from "../services/constants";
import { getCurrentMonth } from "../utils/date";
export const dashboardPageData = {
  lastUpdate: "Última actualización: Lunes, 17 de Julio, 2023 - 8:55 a.m.",
  daysLeft: (days) => `Te quedan ${days} días disponibles`,
  welcomeMessage: (name) => `¡Bienvenido ${name}!`,
  shareMessage: `Comparte este enlace con tus contactos y bríndales increíbles beneficios en sus desafíos ${brandName}.`,
  salesHistorySeccionTitle: "Histórico de ventas por cuentas",
  progress: [
    {
      key: "points",
      title: "Puntos",
      value: "Pts",
      legend: {
        initial: "pts",
        final: "pts",
      },
      progress: 70,
    },
  ],
  statistics: [
    {
      key: "currentLevel",
      title: "Nivel actual",
      value: "",
      show: true,
    },
    {
      key: "duration",
      title: "Días restantes del ciclo",
      value: 0,
      show: false,
    },
    {
      key: "repeats",
      title: "Vidas conseguidas",
      value: "Vidas",
      show: false,
    },
    {
      key: "capital",
      title: "Capital acumulado",
      value: "",
      show: false,
    },
    {
      key: "ibCommissions",
      title: "Comisiones del ciclo",
      value: "",
      show: false,
    },
    {
      key: "clicks",
      title: "Clicks",
      value: "Clicks",
      show: true,
    },
    {
      key: "totalRecords",
      title: "Registros totales",
      value: "",
      show: true,
    },
    {
      key: "salesCount",
      title: "Numero de Ventas Realizadas",
      value: "",
      show: true,
    },
    {
      key: "conversionRate",
      title: "Conversion rate",
      value: "%",
      show: true,
    },
    {
      key: "totalSales",
      title: "Ventas Realizadas",
      value: "",
      show: false,
    },
    {
      key: "totalCommissions",
      title: "Comisiones",
      value: "",
      show: false,
    },
    // {
    //   key: "totalCommissions",
    //   title: `Total comisiones (${getCurrentMonth().toUpperCase()})`,
    //   value: "",
    //   show: true,
    // },
  ],
};
